import { useFeatures } from '@/hooks/api/useFeatures';
import { Channels } from '@/components/features/top/Channels';
import { Features } from '@/components/features/top/Features';
import { Menu } from '@/components/layout/Menu';
import { AppLayout } from '@/components/layout/AppLayout';
import { Playlists } from '@/components/features/top/Playlists';

export const Top = () => {
  const { data: features } = useFeatures();

  return (
    <AppLayout type={'top'}>
      <section className="kv ch">
        <div className="img p1">
          <div className="ch-logo-wrapper">{/*<div className="ch-logo" aria-label="City Heaven TV"></div>*/}</div>
        </div>
      </section>

      <div className="global-container">
        <Menu />

        <div className="content-main top">
          <Channels />
          <Playlists />
          <Features />
        </div>
      </div>
    </AppLayout>
  );
};
